export default {
    RECEIVE_MAP_SHAPE: 'RECEIVE_MAP_SHAPE',
    RECEIVE_MAP_SHAPES: 'RECEIVE_MAP_SHAPES',
    DELETE_MAP_SHAPE: 'DELETE_MAP_SHAPE',
};
